import type { ColDefWithID } from '../contrains/ColumnTypes'
import { columnFactory, createDefaultColumns } from '../contrains/ColumnTypes'
import type { CellData, TableRowData } from '../types/data'
import { rowFactory } from './rows'
import type { Elemental } from '~~/src/types/elemental'
import type { TableRowsAndColumnsResponse } from '~~/src/api/table'

export function getInitialTableData() {
  const columns = ([...createDefaultColumns(['Name', 'Bio', 'Services'])]) as ColDefWithID[]
  const rowData = Array.from({ length: 3 }).map((_) => {
    const data = {
      ...rowFactory(),
    }

    for (const col of columns) {
      // @ts-expect-error variable is defined
      data[col.colId] = {
        template: '',
      }
    }

    return data
  }) as TableRowData[]

  return {
    columns,
    rowData,
  }
}

export function parseColumnsAndRowsFromData(data: TableRowsAndColumnsResponse, tableMetadata?: Elemental['metadata']) {
  const metadata = tableMetadata ?? {} as Record<string, unknown>
  const getColumnMetadata = (id: string) => {
    // @ts-expect-error - This is a valid property
    const meta = metadata[id]
    return (meta ?? {}) as ColDefWithID
  }
  const newColumns = data.columns.map((column) => {
    const field = `${column.field}` as string
    const data = {
      ...column,
      ...getColumnMetadata(field),
      colId: field,
      field,
      editable: true,
      context: column,
    }
    const newColumn = columnFactory('base', data)
    return newColumn
  })

  const newRows = data.rows.map((row) => {
    const newRow = {
      ...unref(row),
      id: row.field ?? randomID(),
    } as TableRowData
    return newRow
  })
  const columns = newColumns
  const rowData = newRows

  return {
    columns,
    rowData,
  }
}

export function getCellData(
  row: TableRowData | undefined, coldId?: string,
) {
  if (!row || !coldId)
    return null

  // @ts-expect-error - This is a valid property
  const data = row[coldId] as CellData | undefined

  if (!data)
    return null
  return data
}
